/**
 * @file
 * Mitglieder select filters - init SlimSelect and auto-submit on change.
 *
 * Dropdown changes and the name search both submit the Views exposed form,
 * so category, status and the search text stay applied together.
 */
(() => {
  (function (Drupal, once) {
    'use strict';

    function submitExposedForm(form) {
      const submit = form.querySelector('input[type="submit"].js-form-submit, input[type="submit"][id^="edit-submit-"]');

      // Click the Views submit directly. A mousedown would start Views AJAX,
      // which on this site does not apply the exposed filter values. The click
      // submits the whole form, including the other filters and the name field.
      if (submit) {
        submit.click();
        return;
      }

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      }
      else {
        form.submit();
      }
    }

    Drupal.behaviors.mitgliederSelectFilter = {
      attach: function (context) {
        if (typeof window.initSlimSelect === 'function') {
          window.initSlimSelect();
        }

        once('mitgliederSelectSubmit', '[data-filter-select]', context).forEach(function (select) {
          const form = select.closest('form');

          if (!form) {
            return;
          }

          select.addEventListener('change', function () {
            submitExposedForm(form);
          });
        });

        // Name search on listings that do not use the alphabet filter.
        // The Mitglieder overview handles its own search button.
        once('mitgliederNameSearch', '.mitglieder-name-search', context).forEach(function (wrap) {
          const form = wrap.closest('form');
          const input = wrap.querySelector('input[type="text"], input[type="search"]');
          const button = wrap.querySelector('button');

          if (!form || form.querySelector('[data-filter-alphabet]')) {
            return;
          }

          function submitSearch(event) {
            event.preventDefault();
            submitExposedForm(form);
          }

          if (button) {
            button.addEventListener('click', submitSearch);
          }
          if (input) {
            input.addEventListener('keydown', function (event) {
              if (event.key === 'Enter') {
                submitSearch(event);
              }
            });
          }
        });
      }
    };
  })(Drupal, once);
})();
